/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'roomplan-paid': {
    width: 16,
    height: 32,
    viewBox: '0 -1 16 32',
    data: '<g transform="translate(-7.75 .25)" _fill="none" fill-rule="evenodd" _stroke="#000" stroke-linecap="round" stroke-linejoin="round"><polyline pid="0" points="21.5 11 13 20.5 10 17.5"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/roomplan-paid.js